export const POPOUP_SHOW = "popoup_show";
export const POPOUP_HIDE = "popoup_hide";
export const SURVEY_ANSWERED = "survey_answered";
export const SURVEY_CHANGE_STEP = "survey_change_step";
export const SURVEY_START = "survey_start";
export const SURVEY_QUESTS_UPLOADED = "survey_quests_uploaded";
export const SURVEY_ANSWERS_UPLOADED = "survey_answers_uploaded";
export const SURVEY_RESULT_UPLOADED = "survey_result_uploaded";
export const SURVEY_UPLOAD_RESULT = "survey_upload_result";
export const SURVEY_PREPARE = "survey_prepare";
export const SURVEY_PREPARED = "survey_prepared";
export const USER_SET_EMAIL = "user_set_email";
export const USER_SURVEY_PASSED = "user_survey_passed";
export const USER_SIGN_OUT = "user_sign_out";
export const USER_FETCH = "user_fetch";
export const USER_BUY = "user_buy";
export const USER_GET_BY_ID = "user_get_by_id";
export const USER_CREATE = "user_create";
export const AUTH_UPDATED = "auth_updated";
export const USER_FETCHING = "user_fetching";
export const USER_LANGUAGE = "user_language";
export const USER_LANGUAGE_SWITCHED = "user_language_switched";
export const USER_LANGUAGE_SWITCH = "user_language_switch";
export const CREATE_USER_WITH_EMAIL_AND_PASSWORD = "create_user_with_email_and_password";
export const SIGN_IN_USER_WITH_EMAIL_AND_PASSWORD = "sign_in_user_with_email_and_password";
export const SEND_PASSWORD_RESET_EMAIL = "send_password_reset_email";
export const ORDERS_DOWNLOADED = "orders_downloaded";
export const ORDERS_UPLOADED = "orders_uploaded";
export const ORDERS_FETCHING = "orders_fetching";
export const ORDERS_CHECKED = "orders_checked";

export function Action(type, payload = null) {
	return { type, payload };
}



// WEBPACK FOOTER //
// ./src/actions/index.js